import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@cinch-labs/design-system";
import classnames from "classnames";
import React from "react";
import styles from "./accordion.module.css";
var handleArrowDown = function(accordionIndex, totalItems) {
    var nextAccordionIndex = accordionIndex + 1;
    if (accordionIndex === totalItems) {
        return 1;
    }
    return nextAccordionIndex;
};
var handleArrowUp = function(accordionIndex, totalItems) {
    var nextAccordionIndex = accordionIndex - 1;
    if (accordionIndex === 1) {
        return totalItems;
    }
    return nextAccordionIndex;
};
var getOpenAccordionKeyCode = function(id) {
    return {
        "13": function() {
            return id;
        },
        "32": function() {
            return id;
        }
    };
};
var getKeyCodes = function(id, totalItems) {
    return {
        "40": function() {
            return handleArrowDown(id, totalItems);
        },
        "38": function() {
            return handleArrowUp(id, totalItems);
        },
        "36": function() {
            return 1;
        },
        "35": function() {
            return totalItems;
        }
    };
};
var AccordionButton = function(param, ref) {
    var isExpanded = param.isExpanded, id = param.id, toggleExpanded = param.toggleExpanded, buttonText = param.buttonText, totalItems = param.totalItems, setFocusActive = param.setFocusActive, buttonId = param.buttonId, sectionId = param.sectionId, iconType = param.iconType, iconGradient = param.iconGradient;
    var iconGradientFill = iconGradient ? iconGradient : undefined;
    var iconColorFill = !iconGradient ? "deepPurple" : undefined;
    var keyboardEventHandler = function(event) {
        var keyCodes = getKeyCodes(id, totalItems);
        var openAccordionKeyCode = getOpenAccordionKeyCode(id);
        if (event.keyCode in openAccordionKeyCode) {
            event.preventDefault();
            toggleExpanded();
            return;
        }
        if (event.keyCode in keyCodes) {
            event.preventDefault();
            setFocusActive(keyCodes[event.keyCode]());
            return;
        }
    };
    return /*#__PURE__*/ _jsx("h3", {
        className: styles.accordionTitle,
        children: /*#__PURE__*/ _jsxs("button", {
            type: "button",
            "aria-expanded": isExpanded,
            "aria-disabled": isExpanded,
            "aria-controls": "".concat(sectionId, "-").concat(id),
            id: "".concat(buttonId, "-").concat(id),
            "data-testid": "".concat(buttonId, "-").concat(id),
            onClick: toggleExpanded,
            onKeyDown: keyboardEventHandler,
            ref: ref,
            className: styles.accordionButton,
            children: [
                iconType ? /*#__PURE__*/ _jsx(SvgIcon, {
                    name: iconType,
                    className: styles.icon,
                    color: iconColorFill,
                    size: 24,
                    gradient: iconGradientFill
                }) : null,
                buttonText,
                /*#__PURE__*/ _jsx(SvgIcon, {
                    name: "chevron-down",
                    className: classnames(styles.chevron, _define_property({}, styles.chevronRotate, isExpanded)),
                    color: "deepPurple",
                    size: 16
                })
            ]
        })
    });
};
export default /*#__PURE__*/ React.forwardRef(AccordionButton);
